export var commodityProducts = [
    { title: "NRML", value: "NRML", eventKey: "M", rank: 1 },
    { title: "MIS", value: "MIS", eventKey: "I", rank: 2 },
    { title: "BO", value: "BO", eventKey: "B", rank: 3 },
];
export var commodityOrder = [
    // { title: "Market", value: "Market", rank: 1 },
    // { title: "Limit", value: "Limit", rank: 2 },
    // { title: "SL", value: "SL", rank: 3 },
    { title: "MARKET", value: "MARKET", rank: 1 },
    { title: "LIMIT", value: "LIMIT", rank: 2 },
    { title: "SL", value: "STOP_LIMIT", rank: 3 },
    // { title: "SL-M", value: "SL-M", rank: 4 },
];
export var commodityValidity = [
    { title: "Day", value: "Day", rank: 1 },
    { title: "IOC", value: "IOC", rank: 2 },
];
export var Evalidity;
(function (Evalidity) {
    Evalidity["ONE_5M"] = "5";
    Evalidity["ONE_10M"] = "10";
    Evalidity["ONE_30M"] = "30";
    Evalidity["ONE_1H"] = "120";
})(Evalidity || (Evalidity = {}));
export var timeperiodValidity = [
    { title: "5 Mins", value: Evalidity.ONE_5M },
    { title: "10 Mins", value: Evalidity.ONE_10M },
    { title: "30 Mins", value: Evalidity.ONE_30M },
    { title: "1 Hour", value: Evalidity.ONE_1H },
];
export var orderList = [
    { title: "Action", value: "Buy" },
    { title: "Product type", value: "F&O (NRML)" },
    { title: "Order type", value: "Market" },
    { title: "No of Lots", value: "2 (Qty: 100)" },
    { title: "Margin required", value: "14,806.75" },
    { title: "Available", value: "5,000.00" },
];
